import { useContext } from 'react';
import { scopeContext } from './scope-context';

export function useScope() {
  const scope = useContext(scopeContext);
  if (!scope) {
    throw new Error(
      'scopeContext value is undefined. Make sure you use the ScopeProvider before using the context.'
    );
  }
  return scope;
}
